import { parsePhoneNumber } from './parsePhoneNumber';

export function isValidPhoneNumber(value: string) {
	try {
		return parsePhoneNumber(value).isValid();
	} catch {
		return false;
	}
}
